<template>
  <div id="app">
    <RTHeader />
    <b-container class="mt-5">
      <h2 class="header-pegaso">Tariffe Pegaso - in vigore dal 01/08/2026</h2>
      <b-row class="mb-5">
        <b-col>
          <p>
            Pegaso è un sistema tariffario regionale che consente un utilizzo combinato delle diverse
            modalità di trasporto extraurbano (autolinee e ferrovie regionali) ed urbano, tramite il quale 
            il passeggero, acquistando un unico titolo di viaggio, può sfruttare pienamente le opportunità 
            offerte dalla rete del trasporto pubblico regionale sia su treno che su autobus.
          </p>
        </b-col>
      </b-row>
      
      <FormTariffe />

      <p>
        Gli abbonamenti <b>PEGASO</b> consentono di utilizzare indifferentemente tutti i mezzi
        di trasporto pubblico locale che collegano le località di origine e destinazione dello spostamento, con possibilità 
        di salita e discesa in tutte le fermate comprese nel collegamento.
      </p>
      <p>
        Gli abbonamenti <strong>PEGASO</strong> possono essere acquistati online presso i siti web delle
        aziende di trasporto o presso le biglietterie delle aziende di trasporto e i rivenditori autorizzati che espongono 
        il marchio <b>PEGASO</b>.
      </p>
      <p>
        Per conoscere meglio le caratteristiche del sistema tariffario integrato regionale, ed in particolare 
        il loro costo, potete utilizzare il "motore di ricerca tariffe PEGASO" proposto, telefonare gratuitamente 
        al <strong>Numero Verde 800-570530</strong> della Regione Toscana, oppure contattare le principali biglietterie 
        e rivendite di Autolinee Toscane, TFT e Trenitalia, presenti in Toscana.
      </p>
    </b-container>
    <RTFooter />
  </div>
</template>

<script>
import FormTariffe from "./components/FormTariffe.vue";
import RTHeader from "./components/RTHeader.vue";
import RTFooter from "./components/RTFooter.vue";

export default {
  name: "App",
  components: {
    FormTariffe,
    RTHeader,
    RTFooter
  }
};
</script>

<style lang="scss">
@import "@/assets/_custom.scss";
@import "~bootstrap/scss/bootstrap.scss";
@import "~bootstrap-vue/src/index.scss";
@import url('https://fonts.googleapis.com/css2?family=Libre+Franklin:ital,wght@0,400;0,700;1,400;1,700&display=swap');
@import url('https://www.regione.toscana.it/o/regione-toscana-theme/css/main.css?browserId=other&themeId=regionetoscana_WAR_regionetoscanatheme&minifierType=css&languageId=it_IT&b=7110&t=1623677978707');

body {
  font-family: 'Libre Franklin', sans-serif;
}

h1, h2, h3, h4 {
    font-weight: bold;
}

.header-pegaso {
  // color: #BC252C;
  // border-bottom: solid 2px #BC252C;
  font-size: 1.5em;
}

a {
  color: #C9232A;
}

a:hover {
  text-decoration: none;
}

// RT css
.rt-navbar {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    --blue: #007bff;
    --indigo: #6610f2;
    --purple: #6f42c1;
    --pink: #e83e8c;
    --red: #dc3545;
    --orange: #fd7e14;
    --yellow: #ffc107;
    --green: #28a745;
    --teal: #20c997;
    --cyan: #17a2b8;
    --white: #fff;
    --gray: #6c757d;
    --gray-dark: #343a40;
    --primary: #007bff;
    --secondary: #6c757d;
    --success: #28a745;
    --info: #17a2b8;
    --warning: #ffc107;
    --danger: #dc3545;
    --light: #f8f9fa;
    --dark: #343a40;
    --breakpoint-xs: 0;
    --breakpoint-sm: 576px;
    --breakpoint-md: 768px;
    --breakpoint-lg: 992px;
    --breakpoint-xl: 1200px;
    --font-family-sans-serif: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
    --font-family-monospace: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
    font-weight: 400;
    text-align: left;
    color: #333;
    font-family: "Libre Franklin",sans-serif;
    font-size: 16px;
    line-height: 1.4;
    -webkit-font-smoothing: antialiased;
    -webkit-text-size-adjust: 100%;
    text-rendering: optimizeLegibility;
    font-variant-ligatures: common-ligatures;
    box-sizing: inherit;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: .5rem 1rem;
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
    border-width: 0;
}
</style>